import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { ApiService, WhoAmI$Response } from '@api/service';
// import * as UserAction from '../actions/user.action';
import * as appAction from './../actions';
import { Store } from '@ngrx/store';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class StatusEffects {
  @Effect()
  getUser$ = this.actions$.pipe(
    ofType(appAction.getStatus),
    switchMap(() => {
      return this.api.subscription.getSubscriptionStatus().pipe(
        map(user => appAction.getStatusSuccess(user)),
        catchError(err => of(appAction.getStatusFail(err)))
      );
    })
  );

  constructor(private actions$: Actions, private api: ApiService, private store: Store<any>) {}
}
